import css from '@emotion/css';
import styled from '@emotion/styled';

export type ScrollTriggerPosition = 'top' | 'bottom' | 'left' | 'right';

export const StyledScrollTrigger = styled.div<{
  size: number;
  isActive?: boolean;
  zIndex?: number;
  position?: ScrollTriggerPosition;
  offset?: number;
  isFixed?: boolean;
}>`
  ${({
    size = 88,
    isActive = false,
    zIndex = 1,
    position = 'bottom',
    offset = 0,
    isFixed = false,
  }) => css`
    position: ${isFixed ? 'fixed' : 'absolute'};
    height: ${['top', 'bottom'].includes(position) ? `${size}px` : null};
    width: ${['left', 'right'].includes(position) ? `${size}px` : null};
    z-index: ${zIndex};
    pointer-events: ${isActive ? 'auto' : 'none'};
    top: ${position === 'bottom'
      ? null
      : `${position === 'top' ? offset : 0}px`};
    bottom: ${position === 'top'
      ? null
      : `${position === 'bottom' ? offset : 0}px`};
    left: ${position === 'right'
      ? null
      : `${position === 'left' ? offset : 0}px`};
    right: ${position === 'left'
      ? null
      : `${position === 'right' ? offset : 0}px`};
  `};
`;
